import React from 'react'

export const SectionCardJobsDemo = () => {
  const jobs = [
    {
      title: 'Senior Software Engineer',
      type: 'Full-time',
      location: 'Remote',
      image: 'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/F4.jpg',
    },
    {
      title: 'Lead Product Designer',
      type: 'Full-time',
      location: 'Remote',
      image: 'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M3.jpg',
    },
    {
      title: 'Senior Frontend Developer',
      type: 'Part-time',
      location: 'Remote',
      image: 'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/F5.jpg',
    },
  ]
  return (
    <section
      className='mk-comp mk-comp-section relative'
      data-component-type='section'
      style={
        {
          width: 'calc(100% + 0px)',
          alignSelf: 'center',
          margin: '0px',
          padding: '20px 10px 0px',
          '--field-color-label': 'var(--color-on-primary-20)',
          '--field-color-bg': 'var(--color-primary-95)',
          '--field-color-fg': 'var(--color-on-primary-95)',
          '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
          '--field-color-accent': 'var(--color-primary-40)',
          '--field-color-on-accent': 'var(--color-on-primary-40)',
          '--field-color-active': 'var(--color-on-primary-95)',
          '--field-color-on-active': 'var(--color-primary-95)',
          '--field-color-focus': 'var(--color-primary-50)',
          '--field-color-thumb': 'var(--color-primary-90)',
          '--field-color-on-thumb': 'var(--color-on-primary-90)',
          '--field-color-checked': 'var(--color-primary-40)',
          '--field-color-unchecked': 'var(--color-primary-10)',
          '--field-color-border': 'var(--color-neutral-60)',
          '--field-color-outline': 'var(--color-neutral-60)',
          '--focus-border': 'var(--color-primary-50)',
          '--focus-ring': 'var(--color-primary-50)',
          '--border-radius': 'var(--radius-md)',
          '--field-label-font': 'var(--typo-label-large-font)',
          '--field-input-font': 'var(--typo-body-medium-font)',
          '--field-supporting-text-font': 'var(--typo-label-small-font)',
          color: 'rgba(0, 0, 0, 0.98)',
          borderRadius: 'var(--radius-md)',
          '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
          zIndex: 0,
          maxWidth: '100%',
          minHeight: '100%',
          height: 'auto',
          overflow: 'hidden',
          gap: '0px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        } as React.CSSProperties
      }
    >
      <div
        className='absolute inset-0'
        style={{
          overflow: 'hidden',
          borderRadius: 'inherit',
          zIndex: -1,
          borderTop: '0px solid var(--color-primary-70)',
          borderInlineEnd: '0px solid var(--color-primary-70)',
          borderBottom: '0px solid var(--color-primary-70)',
          borderInlineStart: '0px solid var(--color-primary-70)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -1,
            backgroundColor: 'rgb(0, 0, 0)',
            opacity: 0,
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -2,
            color: 'currentcolor',
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -3,
            objectFit: 'cover',
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -4,
            backgroundImage: 'url("undefined")',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundAttachment: 'scroll',
            transition: 'transform 0.1s ease-out',
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -5,
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -6,
            background: 'var(--color-primary-20)',
          }}
        ></div>
      </div>
      <div className='mb-4'>
        <h2 className='text-2xl font-bold text-[var(--color-on-primary-20)] mb-0'>Jobs</h2>
      </div>

      {jobs.map((job, index) => (
        <section
          key={index}
          className='mk-comp mk-comp-section relative'
          data-component-type='section'
          style={
            {
              width: 'calc(100% + 0px)',
              alignSelf: 'center',
              margin: '0px 0px 16px',
              padding: '8px 0 4px 0',
              color: 'rgba(0, 0, 0, 0.98)',
              borderRadius: '8px',
              '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
              zIndex: 0,
              maxWidth: '100%',
              minHeight: '100%',
              height: 'auto',
              overflow: 'hidden',
              gap: '0px',
              position: 'relative',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            } as React.CSSProperties
          }
        >
          <style>
            {`.mk-comp-section > .mk-comp {
            height: auto !important;
          }`}
          </style>
          <div
            className='absolute inset-0'
            style={{
              overflow: 'hidden',
              borderRadius: 'inherit',
              zIndex: -1,
              borderTop: '0px solid var(--color-primary-70)',
              borderInlineEnd: '0px solid var(--color-primary-70)',
              borderBottom: '0px solid var(--color-primary-70)',
              borderInlineStart: '0px solid var(--color-primary-70)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -1,
                backgroundColor: 'rgb(0, 0, 0)',
                opacity: 0,
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -2,
                color: 'currentcolor',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -3,
                objectFit: 'cover',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -4,
                backgroundImage: 'url("undefined")',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundAttachment: 'scroll',
                transition: 'transform 0.1s ease-out',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -5,
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -6,
                background: 'var(--color-primary-30)',
              }}
            ></div>
          </div>

          <section
            className='mk-comp mk-comp-section relative'
            data-component-type='section'
            style={
              {
                width: 'calc(30% + 0px)',
                alignSelf: 'center',
                margin: '0px',
                padding: '0px',
                '--field-color-label': 'var(--color-on-primary-20)',
                '--field-color-bg': 'var(--color-primary-95)',
                '--field-color-fg': 'var(--color-on-primary-95)',
                '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
                '--field-color-accent': 'var(--color-primary-40)',
                '--field-color-on-accent': 'var(--color-on-primary-40)',
                '--field-color-active': 'var(--color-on-primary-95)',
                '--field-color-on-active': 'var(--color-primary-95)',
                '--field-color-focus': 'var(--color-primary-50)',
                '--field-color-thumb': 'var(--color-primary-90)',
                '--field-color-on-thumb': 'var(--color-on-primary-90)',
                '--field-color-checked': 'var(--color-primary-40)',
                '--field-color-unchecked': 'var(--color-primary-10)',
                '--field-color-border': 'var(--color-neutral-60)',
                '--field-color-outline': 'var(--color-neutral-60)',
                '--focus-border': 'var(--color-primary-50)',
                '--focus-ring': 'var(--color-primary-50)',
                '--border-radius': 'var(--radius-md)',
                '--field-label-font': 'var(--typo-label-large-font)',
                '--field-input-font': 'var(--typo-body-medium-font)',
                '--field-supporting-text-font': 'var(--typo-label-small-font)',
                color: 'rgba(0, 0, 0, 0.98)',
                borderRadius: '0px',
                '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
                zIndex: 0,
                maxWidth: '100%',
                minHeight: '100%',
                height: 'auto',
                overflow: 'hidden',
                gap: '0px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              } as React.CSSProperties
            }
          >
            <style>
              {`.mk-comp-section > .mk-comp {
              height: auto !important;
            }`}
            </style>
            <div
              className='absolute inset-0'
              style={{
                overflow: 'hidden',
                borderRadius: 'inherit',
                zIndex: -1,
                borderTop: '0px solid var(--color-primary-70)',
                borderInlineEnd: '0px solid var(--color-primary-70)',
                borderBottom: '0px solid var(--color-primary-70)',
                borderInlineStart: '0px solid var(--color-primary-70)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -1,
                  backgroundColor: 'rgb(0, 0, 0)',
                  opacity: 0,
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -2,
                  color: 'currentcolor',
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -3,
                  objectFit: 'cover',
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -4,
                  backgroundImage: 'url("undefined")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundAttachment: 'scroll',
                  transition: 'transform 0.1s ease-out',
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -5,
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -6,
                  // background: 'rgb(198, 241, 232)',
                }}
              ></div>
            </div>
            <div
              className='mk-comp relative inset-0 overflow-hidden rounded-lg'
              id='435b7420-4abb-481f-b679-eb527abdaeeb'
              data-el='435b7420-4abb-481f-b679-eb527abdaeeb'
              style={{
                borderWidth: '0px',
                backgroundColor: 'var(--color-neutral-70)',
                borderColor: 'var(--color-primary-80)',
                aspectRatio: '1 / 1',
                width: 'min(100%, calc(100% - 20px))',
                alignSelf: 'unset',
                margin: '20px 10px',
                padding: '0px',
              }}
            >
              <img src={job.image} alt='' className='w-full h-full object-cover rounded-lg' />
              <div className='absolute top-2 left-2 right-2 z-10 flex items-center justify-between max-w-full overflow-hidden gap-2'></div>
            </div>
          </section>

          <section
            className='mk-comp mk-comp-section relative'
            data-component-type='section'
            style={
              {
                width: 'calc(100% + 0px)',
                alignSelf: 'center',
                margin: '0px',
                padding: '0px',
                '--field-color-label': 'var(--color-on-primary-20)',
                '--field-color-bg': 'var(--color-primary-95)',
                '--field-color-fg': 'var(--color-on-primary-95)',
                '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
                '--field-color-accent': 'var(--color-primary-40)',
                '--field-color-on-accent': 'var(--color-on-primary-40)',
                '--field-color-active': 'var(--color-on-primary-95)',
                '--field-color-on-active': 'var(--color-primary-95)',
                '--field-color-focus': 'var(--color-primary-50)',
                '--field-color-thumb': 'var(--color-primary-90)',
                '--field-color-on-thumb': 'var(--color-on-primary-90)',
                '--field-color-checked': 'var(--color-primary-40)',
                '--field-color-unchecked': 'var(--color-primary-10)',
                '--field-color-border': 'var(--color-neutral-60)',
                '--field-color-outline': 'var(--color-neutral-60)',
                '--focus-border': 'var(--color-primary-50)',
                '--focus-ring': 'var(--color-primary-50)',
                '--border-radius': 'var(--radius-md)',
                '--field-label-font': 'var(--typo-label-large-font)',
                '--field-input-font': 'var(--typo-body-medium-font)',
                '--field-supporting-text-font': 'var(--typo-label-small-font)',
                color: 'rgba(0, 0, 0, 0.98)',
                borderRadius: '0px',
                '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
                zIndex: 0,
                maxWidth: '100%',
                minHeight: '100%',
                height: 'auto',
                overflow: 'hidden',
                gap: '0px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              } as React.CSSProperties
            }
          >
            <style>
              {`.mk-comp-section > .mk-comp {
              height: auto !important;
            }`}
            </style>
            <div
              className='absolute inset-0'
              style={{
                overflow: 'hidden',
                borderRadius: 'inherit',
                zIndex: -1,
                borderTop: '0px solid var(--color-primary-70)',
                borderInlineEnd: '0px solid var(--color-primary-70)',
                borderBottom: '0px solid var(--color-primary-70)',
                borderInlineStart: '0px solid var(--color-primary-70)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -1,
                  backgroundColor: 'rgb(0, 0, 0)',
                  opacity: 0,
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -2,
                  color: 'currentcolor',
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -3,
                  objectFit: 'cover',
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -4,
                  backgroundImage: 'url("undefined")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundAttachment: 'scroll',
                  transition: 'transform 0.1s ease-out',
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -5,
                }}
              ></div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: -6,
                  // background: 'rgb(198, 241, 232)',
                }}
              ></div>
            </div>

            <div
              className='mk-comp border border-solid rounded-md text-base break-words text-start text-on-primary-20 t94x3a7'
              id='e1c66e1f-f448-4c90-a091-48e8b541a3e6'
              data-el='e1c66e1f-f448-4c90-a091-48e8b541a3e6'
              style={
                {
                  '--t94x3a7-0': 'start',
                  '--t94x3a7-1': 'solid',
                  '--t94x3a7-2': 'var(--color-on-primary-20)',
                  '--t94x3a7-3': '1px',
                  '--t94x3a7-4': '0px',
                  '--t94x3a7-5': '0px',
                  '--t94x3a7-6': '0px',
                  '--t94x3a7-7': '0px',
                  width: 'calc(100% + 0px)',
                  alignSelf: 'unset',
                  margin: '0px',
                  padding: '0px 0px 0px 10px',
                  font: 'var(--typo-title-small-font)',
                  letterSpacing: 'var(--typo-title-small-tracking)',
                } as React.CSSProperties
              }
            >
              <span className='mb-3 last:mb-0' style={{ whiteSpace: 'pre-wrap', textAlign: 'start' }}>
                {job.title}
              </span>
              <br />
            </div>

            <div
              className='mk-comp border border-solid rounded-md text-base break-words text-start text-on-primary-20 t94x3a7'
              id='034caf06-2003-46dc-afa0-5a610e11c571'
              data-el='034caf06-2003-46dc-afa0-5a610e11c571'
              style={
                {
                  '--t94x3a7-0': 'start',
                  '--t94x3a7-1': 'solid',
                  '--t94x3a7-2': 'var(--color-on-primary-20)',
                  '--t94x3a7-3': '1px',
                  '--t94x3a7-4': '0px',
                  '--t94x3a7-5': '0px',
                  '--t94x3a7-6': '0px',
                  '--t94x3a7-7': '0px',
                  width: 'calc(100% + 0px)',
                  alignSelf: 'unset',
                  margin: '0px',
                  padding: '0px 10px',
                  font: 'var(--typo-body-medium-font)',
                  letterSpacing: 'var(--typo-body-medium-tracking)',
                } as React.CSSProperties
              }
            >
              <span className='mb-3 last:mb-0' style={{ whiteSpace: 'pre-wrap', textAlign: 'start' }}>
                {job.type}
              </span>
              <br />
            </div>

            <button
              className='mk-comp relative shrink-0 inline-flex items-center gap-2 justify-center text-xs font-medium transition-colors border disabled:opacity-50 disabled:pointer-events-none cursor-pointer rounded-full min-h-10 min-w-10 px-4 bp36a35'
              style={
                {
                  '--bp36a35-0': 'color-mix(in oklab, var(--color-primary-40) 100%, transparent)',
                  '--bp36a35-1': 'var(--color-on-primary-40)',
                  '--bp36a35-3': 'var(--color-primary-50)',
                  font: 'var(--typo-body-extra-small-font)',
                  letterSpacing: 'var(--typo-body-extra-small-tracking)',
                  height: 'auto',
                  width: 'auto',
                  alignSelf: 'flex-start',
                  margin: '4px 10px 10px',
                  padding: '0px 16px',
                } as React.CSSProperties
              }
            >
              {job.location}
            </button>
          </section>
        </section>
      ))}
    </section>
  )
}
